import { sendToMixpanel } from '../mixpanel';

export default (sortOrderSelected: string): void =>
  sendToMixpanel('Select Sort Order', {
    sortOrderSelected,
  });
